import { styled } from "@mui/material/styles";

const LinkText = styled("span")(({ theme }) => ({
  color: theme.palette.primary.greyPrimary,
  textDecoration: "none",
  cursor: "pointer",
  "&:hover": {
    color: theme.palette.primary.mainHover,
  },
}));

export default LinkText;